import { NavigateBackLink } from '@exam-center/components';
import { Flex, PageHeader, Text } from '@shared/components';
import { dayjs, formatDateTime } from '@shared/utils';

import { ExamCenterProctorRequestStatusLabel } from '../../components';
import {
  type ExamCenterProctorRequest,
  useAdminExamCenterProctorRequestDetails,
} from '../../providers';

function getExamCenterProctorRequestHeaderDetails(
  examCenterProctorRequest: ExamCenterProctorRequest,
) {
  const fullName = [
    examCenterProctorRequest.titleTh,
    examCenterProctorRequest.firstNameTh,
    examCenterProctorRequest.middleNameTh,
    examCenterProctorRequest.lastNameTh,
  ]
    .filter(Boolean)
    .join(' ');
  const status = examCenterProctorRequest.step;
  const refCode = examCenterProctorRequest.refCode;
  const examCenter = examCenterProctorRequest.examCenterCode;
  const requestedAt = formatDateTime(dayjs(examCenterProctorRequest.requestedAt).toDate());

  const verdicts = examCenterProctorRequest.verdicts;

  const latestVerdict =
    verdicts.length > 0
      ? verdicts.reduce(
          (prev, curr) => (dayjs(curr.updatedAt).isAfter(dayjs(prev.updatedAt)) ? curr : prev),
          verdicts[0],
        )
      : undefined;

  const lastModifiedAt = latestVerdict
    ? formatDateTime(dayjs(latestVerdict.updatedAt).toDate())
    : '-';
  const lastModifiedBy =
    latestVerdict?.updatedUser?.firstname && latestVerdict?.updatedUser?.lastname
      ? `${latestVerdict.updatedUser.firstname} ${latestVerdict.updatedUser.lastname}`
      : '-';

  return { fullName, status, refCode, examCenter, requestedAt, lastModifiedAt, lastModifiedBy };
}

export default function AdminExamCenterProctorRequestHeader() {
  const { examCenterProctorRequest } = useAdminExamCenterProctorRequestDetails();

  const { fullName, status, refCode, examCenter, requestedAt, lastModifiedAt, lastModifiedBy } =
    getExamCenterProctorRequestHeaderDetails(examCenterProctorRequest);

  return (
    <PageHeader
      title={fullName}
      endAdornment={<ExamCenterProctorRequestStatusLabel variant={status} />}
      subtitleSection={
        <Flex
          sx={{
            justifyContent: 'space-between',
            flex: 1,
          }}
        >
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <Text variant='body2' color='text.secondary'>
              เลขที่คำขอ: {refCode}
            </Text>
            <Text variant='body2' color='text.secondary'>
              ศูนย์ทดสอบ: {examCenter}
            </Text>
            <Text variant='body2' color='text.secondary'>
              วันที่ส่งคำขอ: {requestedAt}
            </Text>
          </Flex>
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <Text variant='body2' color='text.secondary'>
              Last Modified: {lastModifiedAt}
            </Text>
            <Text variant='body2' color='text.secondary'>
              By: {lastModifiedBy}
            </Text>
          </Flex>
        </Flex>
      }
      linkAdornment={<NavigateBackLink to='/admin/exam-proctors/requests' />}
    />
  );
}
